<div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-[40%_27%_27%] gap-8">
  <!-- ================= TOP BORROWER TABLE ================= -->
  <div class="bg-white text-[#444A6D] rounded-[28px] p-6 shadow-sm">
    <h3 class="text-lg font-semibold text-[#0B0D5C] mb-4">
      {{ 'MENU_BOTTOM.TOP_BORROWER' | translate }}
    </h3>

    <!-- Header -->
    <div class="grid grid-cols-12 text-sm text-slate-400 pb-3 border-b">
      <div class="col-span-1">#</div>
      <div class="col-span-4">{{ 'MENU_BOTTOM.NAME' | translate }}</div>
      <div class="col-span-5">{{ 'MENU_BOTTOM.EXPOSURE_FACILITIES' | translate }}</div>
      <div class="col-span-2 text-end">%</div>
    </div>

    <!-- Row -->
    <div class="grid grid-cols-12 items-center py-4 border-b">
      <div class="col-span-1">01</div>
      <div class="col-span-4">Agaahi Pakistan</div>
      <div class="col-span-5">
        <div class="h-2 rounded-full bg-blue-100">
          <div class="h-2 w-[45%] bg-blue-500 rounded-full"></div>
        </div>
      </div>
      <div class="col-span-2 text-end">
        <span class="px-3 py-1 border border-blue-500 text-blue-500 rounded-full text-sm">
          45%
        </span>
      </div>
    </div>

    <div class="grid grid-cols-12 items-center py-4 border-b">
      <div class="col-span-1">02</div>
      <div class="col-span-4">Goldfin</div>
      <div class="col-span-5">
        <div class="h-2 rounded-full bg-green-100">
          <div class="h-2 w-[29%] bg-green-500 rounded-full"></div>
        </div>
      </div>
      <div class="col-span-2 text-end">
        <span class="px-3 py-1 border border-green-500 text-green-500 rounded-full text-sm">
          29%
        </span>
      </div>
    </div>

    <div class="grid grid-cols-12 items-center py-4 border-b">
      <div class="col-span-1">03</div>
      <div class="col-span-4">{{ 'MENU_BOTTOM.PRODUCT_NAME' | translate }}</div>
      <div class="col-span-5">
        <div class="h-2 rounded-full bg-purple-100">
          <div class="h-2 w-[20%] bg-purple-500 rounded-full"></div>
        </div>
      </div>
      <div class="col-span-2 text-end">
        <span class="px-3 py-1 border border-purple-500 text-purple-500 rounded-full text-sm">
          20%
        </span>
      </div>
    </div>

    <div class="grid grid-cols-12 items-center py-4">
      <div class="col-span-1">04</div>
      <div class="col-span-4">{{ 'MENU_BOTTOM.PRODUCT_NAME' | translate }}</div>
      <div class="col-span-5">
        <div class="h-2 rounded-full bg-orange-100">
          <div class="h-2 w-[8%] bg-orange-500 rounded-full"></div>
        </div>
      </div>
      <div class="col-span-2 text-end">
        <span class="px-3 py-1 border border-orange-500 text-orange-500 rounded-full text-sm">
          8%
        </span>
      </div>
    </div>

  </div>


  <!-- ================= MAP SECTION ================= -->
  <div class="bg-white rounded-[28px] p-6 shadow-sm">

    <!-- Title -->
    <h3 class="text-lg font-semibold text-[#444A6D] mb-4">
      {{ 'MENU_BOTTOM.LEADING_BY_REGION' | translate }}
    </h3>

    <!-- Map -->
    <div class="flex items-center justify-center">
      <img
        src="/public/pak12282-8kha.svg"
        [alt]="'MENU_BOTTOM.PAKISTAN_MAP' | translate"
        class="max-h-[260px] object-contain"
      />
    </div>

  </div>


  <!-- ================= TOP RISKY BORROWERS ================= -->
  <div class="bg-white rounded-[28px] p-6 shadow-sm">
    <h3 class="text-lg font-semibold text-[#0B0D5C] mb-4">
      {{ 'MENU_BOTTOM.TOP_RISKY_BORROWERS' | translate }}
    </h3>

    <!-- Chart -->
    <div class="flex items-end justify-between h-[220px] px-4">
      <div class="flex flex-col items-center gap-2">
        <span class="text-sm font-semibold">200</span>
        <div class="w-6 h-[180px] bg-secondary rounded-lg"></div>
        <span class="text-xs text-slate-500">Aghahi</span>
      </div>
      <div class="flex flex-col items-center gap-2">
        <span class="text-sm font-semibold">150</span>
        <div class="w-6 h-[140px] bg-orange-500 rounded-lg"></div>
        <span class="text-xs text-slate-500">Goldfin</span>
      </div>
      <div class="flex flex-col items-center gap-2">
        <span class="text-sm font-semibold">100</span>
        <div class="w-6 h-[100px] bg-green-600 rounded-lg"></div>
        <span class="text-xs text-slate-500">Daimen</span>
      </div>
      <div class="flex flex-col items-center gap-2">
        <span class="text-sm font-semibold">90</span>
        <div class="w-6 h-[90px] bg-purple-500 rounded-lg"></div>
        <span class="text-xs text-slate-500">Kashif</span>
      </div>
      <div class="flex flex-col items-center gap-2">
        <span class="text-sm font-semibold">80</span>
        <div class="w-6 h-[80px] bg-orange-700 rounded-lg"></div>
        <span class="text-xs text-slate-500">FF</span>
      </div>
    </div>
  </div>

</div>